import { defineComponent, createElementBlock, createCommentVNode, openBlock, createBlock, createVNode, withCtx, createTextVNode, toDisplayString, createElementVNode } from 'vue';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es87.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es189.js';
/* empty css                        */
import _sfc_main$4 from './basler-components.es205.js';
/* empty css                        */

const _hoisted_1 = {
  key: 0,
  class: "product-detail"
};
const _hoisted_2 = {
  key: 1,
  class: "headline-module product-detail__headline"
};
const _hoisted_3 = { class: "headline-module__text h1" };
const _hoisted_4 = { class: "product-detail__headline-variant" };
const _hoisted_5 = {
  key: 0,
  class: "product-detail__headline-variant"
};
const _hoisted_6 = {
  key: 3,
  class: "product-detail__description"
};
const _hoisted_7 = {
  key: 4,
  class: "product-detail__description"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetailHeader",
  props: {
    id: {},
    name: {},
    variantName: {},
    description: {},
    attributes: {},
    specialBadge: {},
    isLoading: { type: Boolean, default: false },
    link: {},
    linkText: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.name || _ctx.variantName || _ctx.description || _ctx.attributes ? (openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.link && _ctx.linkText ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          link: _ctx.link,
          "style-type": "link",
          size: "medium",
          class: "product-detail__link"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.linkText), 1)
          ]),
          _: 1
        }, 8, ["link"])) : createCommentVNode("", true),
        _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createVNode(_sfc_main$2, {
            type: "block",
            class: "badge is-medium",
            style: { "width": "58px" }
          }),
          createElementVNode("div", _hoisted_3, [
            createVNode(_sfc_main$2, {
              type: "block",
              style: { "width": "max(25%, 170px)" }
            }),
            createElementVNode("span", _hoisted_4, [
              createVNode(_sfc_main$2, {
                type: "block",
                style: { "width": "max(30%, 200px)" }
              })
            ])
          ])
        ])) : (openBlock(), createBlock(_sfc_main$3, {
          key: 2,
          level: 1,
          "badge-text": _ctx.specialBadge,
          "badge-size": "medium",
          class: "product-detail__headline"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.name) + " ", 1),
            _ctx.variantName ? (openBlock(), createElementBlock("span", _hoisted_5, toDisplayString(_ctx.variantName), 1)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["badge-text"])),
        createVNode(_sfc_main$4, {
          attributes: _ctx.attributes,
          "is-loading": _ctx.isLoading,
          class: "product-detail__features"
        }, null, 8, ["attributes", "is-loading"]),
        _ctx.isLoading ? (openBlock(), createElementBlock("p", _hoisted_6, [
          createVNode(_sfc_main$2, { style: { "width": "75%" } }),
          _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1)),
          createVNode(_sfc_main$2, { style: { "width": "85%" } }),
          _cache[1] || (_cache[1] = createElementVNode("br", null, null, -1)),
          createVNode(_sfc_main$2, { style: { "width": "60%" } })
        ])) : _ctx.description ? (openBlock(), createElementBlock("p", _hoisted_7, toDisplayString(_ctx.description), 1)) : createCommentVNode("", true)
      ])) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
